const ALLOWED = new Set(["http:", "https:", "mailto:"]);

export function safeUrl(url: string): string {
  // Relative URLs (no scheme) — pass through; react-markdown handles them.
  if (!/^[a-z][a-z0-9+.-]*:/i.test(url)) return url;
  try {
    const u = new URL(url);
    return ALLOWED.has(u.protocol) ? url : "";
  } catch {
    return "";
  }
}
